import React from 'react';
import PageLayout from '../UI/PageLayout';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import ProductGroupingPage from '../../containers/Settings/ProductGroupingPage';

const ProductGroupingSettingsPage = () => {
  return (
    <PageLayout
      title="Product Grouping Settings"
      subTitle="Manage product categorization and grouping for different platforms"
      dropdowns={
        <GenericReportingDropdowns
          includeDateRange={true}
          includeSingleSelectRegion={true}
          includeGranularity={false}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          renderAsButton={true}
          includeCompareDateRange={false}
        />
      }
      content={<ProductGroupingPage />}
    />
  );
};

export default ProductGroupingSettingsPage;
